import { defineStore } from 'pinia'

// import {
//   // generateInspirationBase,
//   generateInspirationHotTopic,
//   generateInspirationRandomWords,
//   generateInspirationToScriptTable
// } from '../service/llm'

export const useLLMStore = defineStore('llmStore', {
  state: () => ({
    results: {}
  }),
  actions: {
    // async generateInspirationBase(params) {
    //   return generateInspirationBase(params)
    // },

    // generateInspirationHotTopic(params) {
    //   return generateInspirationHotTopic(params)
    // },
    setResults({ taskId, results }) {
      this.results[taskId] = results
    },

    // async generateInspirationRandomWords(params) {
    //   return await generateInspirationRandomWords(params)
    // },

    // async generateInspirationToScriptTable(params) {
    //   return await generateInspirationToScriptTable(params)
    // },
    updateResultContent(taskId, key, content) {
      if (this.results[taskId] && this.results[taskId][key]) {
        this.results[taskId] = {
          ...this.results[taskId],
          [key]: {
            ...this.results[taskId][key],
            content: content
          }
        }
      }
    }
  }
})
